import { render, staticRenderFns } from "./AlertSingle.vue?vue&type=template&id=21e44118&scoped=true&"
import script from "./AlertSingle.vue?vue&type=script&lang=js&"
export * from "./AlertSingle.vue?vue&type=script&lang=js&"
import style0 from "./AlertSingle.vue?vue&type=style&index=0&id=21e44118&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e44118",
  null
  
)

export default component.exports